<template>
  <b-modal
    id="modal-activity-form"
    title="Thêm mới hoạt động"
    centered
    hide-footer
    size="md"
    @hidden="resetModal"
  >
    <b-overlay :show="loading">
      <form @submit.prevent="handleValidate">
        <div>
          <basic-select
            label="Loại hoạt động"
            placeholder="--- Chọn loại hoạt động ---"
            required
            changeValueByObject
            :options="activityTypes"
            :value.sync="form.type"
            track-by="value"
            value-label="text"
            :allow-empty="false"
            name="type"
            v-validate="'required'"
            :state="validateState('type')"
            :invalidFeedback="errors.first('type')"
            data-vv-as="Loại hoạt động"
            @update:value="selectType"
          />
          <basic-input
            v-if="isFreeActivity"
            label="Tên hoạt động"
            placeholder="Nhập tên hoạt động"
            required
            :value.sync="form.name"
            maxlength="24"
            name="name"
            v-validate="'required'"
            :state="validateState('name')"
            :invalidFeedback="errors.first('name')"
            data-vv-as="Tên hoạt động"
          />
          <div v-if="isFreeActivity">
            <label for=""
              >Thực hiện trong bao lâu <span class="text-danger">*</span></label
            >
            <b-row>
              <b-col>
                <basic-select
                  changeValueByObject
                  :options="executionTimes"
                  track-by="value"
                  value-label="text"
                  placeholder="--- Thời gian ---"
                  :value.sync="form.executionTime"
                  name="time"
                  v-validate="'required'"
                  :state="validateState('time')"
                  :invalidFeedback="errors.first('time')"
                  data-vv-as="Thời gian"
                  @update:value="$validator.reset({ name: 'time' })"
                />
              </b-col>
              <b-col>
                <basic-select
                  changeValueByObject
                  :options="executionTimeUnits"
                  track-by="value"
                  value-label="text"
                  placeholder="--- Đơn vị ---"
                  :value.sync="form.executionTimeUnit"
                  name="unit"
                  v-validate="'required'"
                  :state="validateState('unit')"
                  :invalidFeedback="errors.first('unit')"
                  data-vv-as="Đơn vị"
                  @update:value="$validator.reset({ name: 'unit' })"
                />
              </b-col>
            </b-row>
          </div>
          <basic-select
            v-if="isBookingActivity"
            label="Loại lịch hẹn"
            placeholder="--- Chọn loại lịch hẹn ---"
            required
            changeValueByObject
            :options="bookingTypes"
            :value.sync="form.bookingType"
            track-by="value"
            value-label="text"
            :allow-empty="false"
            name="bookingType"
            v-validate="'required'"
            :state="validateState('bookingType')"
            :invalidFeedback="errors.first('bookingType')"
            data-vv-as="Loại lịch hẹn"
            @update:value="selectBookingType"
          />
          <b-form-group
            v-if="isBookingActivity"
            label="Ngày diễn ra hoạt động"
            :id="`bookingDate-group`"
            label-for="bookingDate-ID"
            :invalid-feedback="errors.first('bookingDate')"
            :state="validateState('bookingDate')"
            class="required"
          >
            <date-picker
              id="bookingDate-ID"
              required
              placeholder="chọn ngày diễn ra hoạt động"
              :disabled-date="disabledBeforeToday"
              v-model="form.bookingDate"
              :format="dateFomartion"
              input-class="form-control"
              type="date"
              value-type="format"
              name="bookingDate"
              v-validate="'required'"
              data-vv-as="Ngày diễn ra hoạt động"
            />
          </b-form-group>
          <!-- Zoom bookings table -->
          <div v-if="isBookingActivity && form.bookingType && form.bookingType.value === 'ZOOM' && zoomBookings.length > 0" class="mt-3 mb-3">
            <label><strong>Danh sách lịch hẹn Zoom</strong></label>
            <b-table-simple bordered small responsive>
              <b-thead>
                <b-tr>
                  <b-th style="width: 50px">Chọn</b-th>
                  <b-th>Tên buổi họp</b-th>
                  <b-th>Thời gian hẹn</b-th>
                  <b-th>Loại đặt hẹn</b-th>
                  <b-th>Trạng thái</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr v-for="(item, index) in zoomBookings" :key="index" :class="{ 'table-primary': selectedZoomBooking === index }" style="cursor: pointer" @click="selectedZoomBooking = index">
                  <b-td class="text-center">
                    <b-form-radio
                      :value="index"
                      v-model="selectedZoomBooking"
                      name="zoomBookingSelect"
                    />
                  </b-td>
                  <b-td>{{ item.name || 'Chưa có tên' }}</b-td>
                  <b-td>{{ formatBookingDate(item.appointmentDate) }} - {{ formatBookingDate(item.appointmentDate + 3600) }}</b-td>
                  <b-td>
                    <span v-if="item.type === 30">Đặt hẹn đầu vào</span>
                    <span v-else-if="item.type === 31">Đặt hẹn đầu ra</span>
                    <span v-else-if="item.type === 32">Đặt hẹn cá nhân</span>
                    <span v-else>-</span>
                  </b-td>
                  <b-td>
                    <span :class="item.isDeleted ? 'text-danger' : 'text-success'">
                      {{ item.isDeleted
                        ? 'Đã hủy'
                        : (item.appointmentDate * 1000 > Date.now()
                          ? 'Sắp tới'
                          : 'Hoàn thành')
                      }}
                    </span>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
          <basic-select
            v-if="isKpiActivity"
            label="Số lần thực hiện trong ngày"
            changeValueByObject
            :options="executionDays"
            track-by="value"
            value-label="text"
            placeholder="--- Chọn số thực hiện trong ngày ---"
            :value.sync="form.numberActivity"
            name="numberActivity"
            v-validate="'required'"
            :state="validateState('numberActivity')"
            :invalidFeedback="errors.first('numberActivity')"
            data-vv-as="Số lần thực hiện trong ngày"
            required
            @update:value="$validator.reset({ name: 'numberActivity' })"
          />
          <template v-if="isKpiActivity || isFreeActivity">
            <basic-select
              label="Tuỳ chọn lặp lại"
              changeValueByObject
              :options="repeatTypes"
              track-by="value"
              value-label="text"
              placeholder="--- chọn tuỳ chọn lặp lại ---"
              :value.sync="form.repeat"
              name="repeat"
              v-validate="'required'"
              :state="validateState('repeat')"
              :invalidFeedback="errors.first('repeat')"
              data-vv-as="Tùy chọn lặp lại"
              required
              @update:value="$validator.reset({ name: 'repeat' })"
            />
          </template>
          <template v-if="(isFreeActivity || isKpiActivity) && isRepeat">
            <b-form-group
              v-if="isWeeklyRepeat"
              label="Lặp lại hàng tuần"
              :id="`repeatWeek-group`"
              label-for="repeatWeek-ID"
              :invalid-feedback="errors.first('repeatWeek')"
              :state="validateState('repeatWeek')"
              class="required"
            >
              <div class="d-flex">
                <v-chip-group
                  v-model="form.daysInWeek"
                  v-validate="{
                    required: true,
                  }"
                  required
                  name="daysInWeek"
                  data-vv-as="Setting lặp lại theo tuần"
                  multiple
                  class="calendar-schedule-loop-modal__chip-group"
                >
                  <v-chip
                    v-for="(options, index) in weekdayOptions"
                    :key="index"
                  >
                    {{ options.text }}
                  </v-chip>
                </v-chip-group>
              </div>
              <div class="invalid-feedback d-block mb-4">
                {{ errors.first('daysInWeek') }}
              </div>
            </b-form-group>
            <b-form-group
              label="Ngày kết thúc"
              :id="`endDate-group`"
              label-for="endDate-ID"
              :invalid-feedback="errors.first('endDate')"
              :state="validateState('endDate')"
              class="required"
            >
              <date-picker
                id="endDate-ID"
                placeholder="chọn ngày kết thúc"
                :disabled-date="disabledBeforeToday"
                v-model="form.endDate"
                :format="dateFomartion"
                input-class="form-control"
                type="date"
                value-type="format"
                name="endDate"
                v-validate="'required'"
                data-vv-as="Tùy chọn lặp lại"
              />
            </b-form-group>
          </template>
          <basic-input
            v-if="isActivity"
            label="Số phút hoạt động theo ngày"
            placeholder="Nhập số phút hoạt động theo ngày"
            input-number
            :value.sync="form.activeMinutes"
          />
          <template v-if="isSurvey">
            <b-form-group
              label="Ngày diễn ra hoạt động"
              :id="`activityDate-group`"
              label-for="activityDate-ID"
              :invalid-feedback="errors.first('activityDate')"
              :state="validateState('activityDate')"
              class="required"
            >
              <date-picker
                id="activityDate-ID"
                required
                placeholder="chọn ngày diễn ra hoạt động"
                :disabled-date="disabledBeforeToday"
                v-model="form.activityDate"
                :format="dateFomartion"
                input-class="form-control"
                type="date"
                value-type="format"
                name="activityDate"
                v-validate="'required'"
                data-vv-as="Ngày diễn ra hoạt động"
              />
            </b-form-group>
            <basic-select
              label="Chọn khảo sát"
              changeValueByObject
              :options="surveyList"
              placeholder="--- Chọn khảo sát ---"
              :value.sync="form.survey"
              name="survey"
              v-validate="'required'"
              :state="validateState('survey')"
              :invalidFeedback="errors.first('survey')"
              data-vv-as="Khảo sát"
            />
          </template>
        </div>
        <div class="d-flex justify-content-end align-items-center mt-4">
          <b-button class="btn mr-2" type="button" @click="onClickCancleBtn">
            Hủy
          </b-button>
          <b-button class="btn btn-success ml-3" type="submit">
            <span class="svg-icon">
              <inline-svg src="/media/svg/icons/Neolex/Basic/save.svg" />
            </span>
            Lưu
          </b-button>
        </div>
      </form>
    </b-overlay>
  </b-modal>
</template>
<script>
import {
  TARGET_REPEAT_TYPES,
  TARGET_TYPES,
} from '../../../../core/plugins/constants';
import DatePicker from 'vue2-datepicker';
import { convertTimestampToDateTime } from '../../../../core/utils/dateUtils';
import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('userDashboard');
export default {
  name: 'Activity',
  components: {
    DatePicker,
  },
  data() {
    return {
      dateFomartion: 'DD/MM/YYYY',
      loading: false,
      activityTypes: [
        {
          text: 'Đo huyết áp',
          value: TARGET_TYPES.BLOOD_PRESSURE,
        },
        {
          text: 'Đo cân nặng',
          value: TARGET_TYPES.WEIGHT,
        },
        {
          text: 'Nhập cảm xúc',
          value: TARGET_TYPES.EMOTION,
        },
        {
          text: 'Cập nhật bữa ăn',
          value: TARGET_TYPES.FOOD,
        },
        {
          text: 'Vận động',
          value: TARGET_TYPES.EXERCISE,
        },
        {
          text: 'Khảo sát',
          value: TARGET_TYPES.SURVEY,
        },
        {
          text: 'Hoạt động tự do',
          value: TARGET_TYPES.FREE,
        },
        {
          text: 'Hoạt động đặt lịch hẹn',
          value: TARGET_TYPES.BOOKING_ONBOARDING_FREE,
        },
        
      ],
      bookingTypes: [
        {
          text: 'Đầu vào',
          value: TARGET_TYPES.BOOKING_ONBOARDING_IN,
        },
        {
          text: 'Đầu ra',
          value: TARGET_TYPES.BOOKING_ONBOARDING_OUT,
        },
        {
          text: 'Đặt lịch phỏng vấn',
          value: TARGET_TYPES.BOOKING_ONBOARDING_FREE,
        },
        {
          text: 'Tham gia Zoom',
          value: 'ZOOM',
        },
      ],
      zoomBookings: [],
      calendarCoachData: [],
      form: {
        type: null,
        repeat: null,
        endDate: null,
        executionTime: null,
        executionTimeUnit: null,
        daysInWeek: [],
        activeMinutes: null,
        survey: null,
        activityDate: null,
        numberActivity: null,
        name: null,
        bookingType: null,
        bookingDate: null,
      },
      weekdayOptions: [
        { text: 'T2', value: 1 },
        { text: 'T3', value: 2 },
        { text: 'T4', value: 3 },
        { text: 'T5', value: 4 },
        { text: 'T6', value: 5 },
        { text: 'T7', value: 6 },
        { text: 'CN', value: 0 },
      ],
      executionTimes: Array.from({ length: 200 }, (_, i) => {
        return {
          text: `${i + 1}`,
          value: i + 1,
        };
      }),
      executionDays: Array.from({ length: 20 }, (_, i) => {
        return {
          text: `${i + 1}`,
          value: i + 1,
        };
      }),
      executionTimeUnits: [
        {
          text: 'Lần',
          value: 1,
        },
        {
          text: 'Phút',
          value: 0,
        },
      ],
      repeatTypes: [
        {
          text: 'Hàng ngày',
          value: TARGET_REPEAT_TYPES.DAILY,
        },
        {
          text: 'Hàng tuần',
          value: TARGET_REPEAT_TYPES.WEEKLY,
        },
        {
          text: 'Không lặp lại',
          value: TARGET_REPEAT_TYPES.NO_REPEAT,
        },
      ],
      surveyList: [],
      appointmentDate: this.$moment(new Date()).format('DD/MM/YYYY'),
    };
  },
  computed: {
    ...mapState(['customerInfo']),
    isActivity() {
      return this.form.type?.value === TARGET_TYPES.EXERCISE;
    },
    isSurvey() {
      return this.form.type?.value === TARGET_TYPES.SURVEY;
    },
    isFreeActivity() {
      return this.form.type?.value === TARGET_TYPES.FREE;
    },
    isBookingActivity() {
      return this.form.type?.value === TARGET_TYPES.BOOKING_ONBOARDING_FREE;
    },
    isKpiActivity() {
      return [
        TARGET_TYPES.BLOOD_PRESSURE,
        TARGET_TYPES.WEIGHT,
        TARGET_TYPES.EMOTION,
        TARGET_TYPES.FOOD,
      ].includes(this.form.type?.value);
    },
    isRepeat() {
      if (!this.form.repeat) return false;
      return this.form.repeat?.value !== TARGET_REPEAT_TYPES.NO_REPEAT;
    },
    isWeeklyRepeat() {
      return this.form.repeat?.value === TARGET_REPEAT_TYPES.WEEKLY;
    },
    patientId() {
      return this.$route.params.id;
    },
  },
  methods: {
    resetModal() {
      this.form = {
        type: null,
        repeat: null,
        endDate: null,
        executionTime: null,
        executionTimeUnit: null,
        daysInWeek: [],
        activeMinutes: null,
        survey: null,
        activityDate: null,
        numberActivity: null,
        name: null,
        bookingType: null,
        bookingDate: null,
      };
      this.zoomBookings = [];
      this.calendarCoachData = [];
      this.$emit('reset');
    },
    onClickCancleBtn() {
      this.$bvModal.hide('modal-activity-form');
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    },
    handleValidate() {
      this.$validator.validateAll().then((result) => {
        if (!result) return;

        this.handleSubmit();
      });
    },
    handleSubmit() {
      let payload = {
        patientId: this.patientId,
        accountId: this.customerInfo.accountId,
        name: this.form.name,
        appointmentDate: this.convertDateToTimestamp(this.appointmentDate),
      };

      if (this.isBookingActivity) {
        if (this.form.bookingType?.value === 'ZOOM') {
          if (this.selectedZoomBooking === null) {
            return this.showToastrMessage('Vui lòng chọn một buổi họp Zoom', 'error');
          }
          const selected = this.zoomBookings[this.selectedZoomBooking];
          return this.submitZoomTarget({
            accountId: this.customerInfo.accountId,
            appointmentDate: selected.appointmentDate,
            patientId: this.patientId,
            type: selected.type,
            name: selected.name,
            calendarId: selected.id,
          });
        }
        return this.submitBookingActivity({
          accountId: this.customerInfo.accountId,
          appointmentDate: this.convertDateToTimestamp(this.form.bookingDate),
          patientId: this.patientId,
          type: this.form.bookingType.value,
        });
      }

      if (this.isFreeActivity) {
        payload = {
          ...payload,
          executeDayTimes: this.form.executionTime.value,
          executeType: this.form.executionTimeUnit.value,
          repeatTime: 0,
          repeatType: this.form.repeat.value,
          endDate: this.convertDateToTimestamp(this.form.endDate),
        };
        if (this.isWeeklyRepeat) {
          payload['targetSchedulerWeeks'] = this.form.daysInWeek.map((el) => ({
            dayInWeek: el,
          }));
        }

        return this.submitFreeActivity(this.removeEmpty(payload));
      }

      if (this.isKpiActivity) {
        payload = {
          ...payload,
          executeDayTimes: this.form.numberActivity.value,
          executeType: 1,
          repeatTime: 0,
          repeatType: this.form.repeat.value,
          endDate: this.convertDateToTimestamp(this.form.endDate),
          type: this.form.type.value,
        };

        if (this.isWeeklyRepeat) {
          payload['targetSchedulerWeeks'] = this.form.daysInWeek.map((el) => ({
            dayInWeek: el,
          }));
        }

        return this.submitKpiActivity(this.removeEmpty(payload));
      }

      if (this.isActivity) {
        payload = {
          ...payload,
          executeDayTimes: Number(this.form.activeMinutes),
        };

        return this.submitActivity(this.removeEmpty(payload));
      }

      payload = {
        ...payload,
        appointmentDate: this.convertDateToTimestamp(this.form.activityDate),
        surveyId: this.form.survey.id,
      };
      return this.submitSurveyActivity(this.removeEmpty(payload));
    },
    async submitFreeActivity(payload) {
      try {
        this.loading = true;
        const { meta, error } = await this.$api.post(
          '/UserDashboard/Target-Custom',
          payload,
        );

        if (!meta.success) {
          return this.showToastrMessage(error.message, 'error');
        }

        this.showToastrMessage('Thêm hoạt động mới thành công', 'success');
        this.onClickCancleBtn();
      } catch (error) {
        this.showToastrMessage(error.message, 'error');
      } finally {
        this.loading = false;
      }
    },
    async submitKpiActivity(payload) {
      try {
        this.loading = true;
        const { meta, error } = await this.$api.post(
          '/UserDashboard/Target-KPI',
          payload,
        );

        if (!meta.success) {
          return this.showToastrMessage(error.message, 'error');
        }

        this.showToastrMessage('Thêm hoạt động mới thành công', 'success');
        this.onClickCancleBtn();
      } catch (error) {
        this.showToastrMessage(error.message, 'error');
      } finally {
        this.loading = false;
      }
    },
    async submitActivity(payload) {
      try {
        this.loading = true;
        const { meta, error } = await this.$api.post(
          '/UserDashboard/Target-Excercise',
          payload,
        );

        if (!meta.success) {
          return this.showToastrMessage(error.message, 'error');
        }

        this.showToastrMessage('Thêm hoạt động mới thành công', 'success');

        this.onClickCancleBtn();
      } catch (error) {
        this.showToastrMessage(error.message, 'error');
      } finally {
        this.loading = false;
      }
    },
    async submitSurveyActivity(payload) {
      try {
        this.loading = true;
        const { meta, error } = await this.$api.post(
          '/UserDashboard/Target-Survey',
          payload,
        );

        if (!meta.success) {
          return this.showToastrMessage(error.message, 'error');
        }

        this.showToastrMessage('Thêm hoạt động mới thành công', 'success');

        this.onClickCancleBtn();
      } catch (error) {
        this.showToastrMessage(error.message, 'error');
      } finally {
        this.loading = false;
      }
    },
    async submitBookingActivity(payload) {
      try {
        this.loading = true;
        const { meta, error } = await this.$api.post(
          '/UserDashboard/Target-Booking',
          payload,
        );

        if (!meta.success) {
          return this.showToastrMessage(error.message, 'error');
        }

        this.showToastrMessage('Đặt lịch hẹn thành công', 'success');
        this.onClickCancleBtn();
      } catch (error) {
        this.showToastrMessage(error.message, 'error');
      } finally {
        this.loading = false;
      }
    },
    async submitZoomTarget(payload) {
      try {
        this.loading = true;
        const { meta, error } = await this.$api.post(
          '/UserDashboard/Target-Zoom',
          payload,
        );

        if (!meta.success) {
          return this.showToastrMessage(error.message, 'error');
        }

        this.showToastrMessage('Đặt lịch Zoom thành công', 'success');
        this.onClickCancleBtn();
      } catch (error) {
        this.showToastrMessage(error.message, 'error');
      } finally {
        this.loading = false;
      }
    },
    async submitZoomBooking() {
      try {
        this.loading = true;

        const customerRes = await this.$api.get(
          `/CustomerReceives?accountId=${this.customerInfo.accountId}`,
        );

        if (!customerRes.meta.success || !customerRes.data || customerRes.data.length === 0) {
          return this.showToastrMessage('Không tìm thấy thông tin khách hàng', 'error');
        }

        const customerData = customerRes.data[0];
        const { coachId, courseId, accountId } = customerData;

        const params = { CoachId: coachId, AccountId: accountId, CourseId: courseId };
        const query = new URLSearchParams(params).toString();

        const [bookedRes, calendarRes] = await Promise.all([
          this.$api.get(`/Calendar/BookedByAccountId?${query}`),
          this.$api.get(`/CalendarCoach?StartTime=${Math.floor(Date.now() / 1000)}&${query}`),
        ]);

        if (bookedRes.meta && bookedRes.data) {
          this.zoomBookings = bookedRes.data;
        }

        if (calendarRes.data) {
          this.calendarCoachData = calendarRes.data;
        }

        if (this.zoomBookings.length === 0) {
          this.showToastrMessage('Không có lịch hẹn Zoom nào', 'error');
        }
      } catch (error) {
        this.showToastrMessage(error.message, 'error');
      } finally {
        this.loading = false;
      }
    },
    showToastrMessage(message, type) {
      if (type === 'error') {
        return this.$toastr.e({
          title: 'Lỗi',
          msg: message,
        });
      }

      return this.$toastr.s({
        title: 'Thành công',
        msg: message,
      });
    },
    selectBookingType(selected) {
      this.$validator.reset({ name: 'bookingType' });
      if (selected.value === 'ZOOM') {
        this.submitZoomBooking();
      } else {
        this.zoomBookings = [];
        this.calendarCoachData = [];
      }
    },
    selectType(selected) {
      if (selected.value === TARGET_TYPES.SURVEY) {
        this.getSurveys();
      }
      this.zoomBookings = [];
      this.calendarCoachData = [];
      this.$validator.reset({ name: 'type' });
    },
    getBookingTypeName(type) {
      const typeMap = {
        [TARGET_TYPES.BOOKING_ONBOARDING_IN]: 'Đầu vào',
        [TARGET_TYPES.BOOKING_ONBOARDING_OUT]: 'Đầu ra',
        [TARGET_TYPES.BOOKING_ONBOARDING_FREE]: 'Đặt lịch phỏng vấn',
      };
      return typeMap[type] || `Loại ${type}`;
    },
    formatTimestamp(timestamp) {
      if (timestamp === null || timestamp === undefined) return '';
      return this.$moment.unix(timestamp).format('DD/MM/YYYY HH:mm');
    },
    formatBookingDate(timestamp) {
      return convertTimestampToDateTime(timestamp);
    },
    async getSurveys() {
      try {
        this.loading = true;
        const { meta, data } = await this.$api.get(
          '/Survey/GetSurveyForTarget',
        );

        if (!meta.success) return;

        this.surveyList = data.map((el) => ({ id: el.id, name: el.name }));
      } catch (error) {
        this.showToastrMessage(error.message, 'error');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.calendar-schedule-loop-modal__chip-group {
  .v-chip {
    border-radius: 50%;
    height: 40px;
    font-size: 13px;
    background-color: #fff;
    border: 1px solid #dddddd;
  }

  .v-chip--active {
    background-color: #008479 !important;
    color: #fff;
  }
}
</style>
